module.exports = __webpack_public_path__ + "com_index_08bg.jpg?3788f5bb3167d3c5cd0d416ac7639538";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_08bg.jpg
// module id = 311
// module chunks = 0